export const columns = [
  {title: '所属区县', key: 'unitName', align: 'center'},
  {
    title: '职务',
    align: 'center',
    render: (h, params) => {
      return h('span', {}, params.row.post === 'dz' ? '队长' : params.row.post === 'dy' ? '队员' : '')
    }
  },
  {title: '负责人', key: 'fzr', align: 'center'},
  {
    title: '性别',
    key: 'sex',
    align: 'center',
    render: (h, params) => {
      return h('span', {}, params.row.sex === '1' ? '男' : '女')
    }
  },
  {title: '电话', key: 'phone', align: 'center'},
  {title: '车号', key: 'carno', align: 'center'},
  {title: '职务', key: 'duty', align: 'center', width: 400},
  {title: '操作', slot: 'action', align: 'center', width: 200}
]
export const dzColumns = [
  {title: '所属区县', key: 'unitName', align: 'center'},
  {
    title: '职务',
    align: 'center',
    render: (h, params) => {
      return h('span', {}, params.row.post === 'dz' ? '队长' : params.row.post === 'dy' ? '队员' : '')
    }
  },
  {title: '负责人', key: 'fzr', align: 'center'},
  {
    title: '性别',
    key: 'sex',
    align: 'center',
    render: (h, params) => {
      return h('span', {}, params.row.sex === '1' ? '男' : '女')
    }
  },
  {title: '电话', key: 'phone', align: 'center'},
  {title: '车号', key: 'carno', align: 'center'},
  {title: '职务', key: 'duty', align: 'center'},
]
export const fdzColumns = [
  {
    title: '职务', key: 'post', align: 'center', render: (h, params) => {
      return h('span', {}, params.row.post === 'fdz' ? '副队长' : params.row.post === 'dy' ? '队员' : '')
    }
  },
  {title: '负责人', key: 'fzr', align: 'center'},
  {title: '电话', key: 'phone', align: 'center'},
  {
    title: '性别',
    key: 'sex',
    width: 100,
    align: 'center',
    render: (h, params) => {
      return h('span', {}, params.row.sex === '1' ? '男' : '女')
    }
  },
]
export const xdColumns = [
  {title: '队长', key: 'dz', align: 'center'},
  {
    title: '职务', key: 'post', align: 'center', render: (h, params) => {
      return h('span', {}, params.row.post === 'xddz' ? '小队队长' : '')
    }
  },
  {title: '成员', key: 'teamPart', align: 'center', width: 400},
]
